import { createStore } from 'vuex';

import { auth } from './auth.module';
import { user } from './user.module';
import { match } from './match.module';
import { classement } from './classement.module';

export default createStore({
  modules: {
    auth,
    user,
    match,
    classement
  }
}); 